import React from 'react';
import './LoginView.scss';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { LoggerFactory } from 'logger';
import TextInput from '../components/TextInput';
import { toast } from 'utils/Toast';
import cn from 'classnames';

import Config from 'Config';
import UserView from '../UserView';
import Button from '../components/Button';
import VersionStamp from 'views/components/VersionStamp';
import EquinixLogo from 'views/components/icons/EquinixLogo';
import ArrowIcon from 'views/components/icons/Arrow2';
import onBoardingPDF from 'static/EquinixWorkBench_PartnerFAQ_v1.4.pdf';

class LoginView extends UserView {
  constructor(props) {
    super(props);
    this._logger = LoggerFactory.getLogger(this);
  }

  _onLoginClicked = (email) => this.beginLogin(email);

  componentDidMount() {
    if (this.isAuthenticated) {
      this._logger.info(`User ${this.user} already logged in, redirecting to /projects`);
      this.props.history.replace('/projects');
    }
  }

  render() {
    return (
      <div className="content-login-view">
        {Config.MAINTENANCE_TEXT && <div className="maintenance-banner">{Config.MAINTENANCE_TEXT}</div>}
        <div className={cn('login', { 'maintenance-mode': !!Config.MAINTENANCE_TEXT })}>
          <div className="introduction">
            <p className="title">Connectivity Studio</p>
            <p className="subtitle">Design your infrastructure for hybrid multicloud and AI</p>
          </div>

          <LoginForm emailSent={this.state.emailSent} onLoginClicked={this._onLoginClicked} />

          <div className="footer">
            <p>
              <a href="https://www.equinix.com/about/legal/terms" target="_blank" rel="noopener noreferrer">
                Terms of Use
              </a>
              <a href="https://www.equinix.com/about/trust-security" target="_blank" rel="noopener noreferrer">
                Security Trust & Transparency
              </a>
              <a href="https://www.equinix.com/about/legal/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Statement
              </a>
            </p>
          </div>
        </div>
        <VersionStamp version={Config.VERSION} />
      </div>
    );
  }
}

class LoginForm extends React.Component {
  static defaultProps = {
    emailSent: false,
    onLoginClicked: null,
  };

  static propTypes = {
    emailSent: PropTypes.bool,
    onLoginClicked: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  _onValueChange = (newValue) => this.setState({ email: newValue.trim() });

  _onLoginClick = (e) => {
    e.preventDefault();

    if (!this.state.email || !this.isValidEmail(this.state.email)) {
      toast('Email is not formatted correctly', 'error');
      return;
    }

    this.props.onLoginClicked(this.state.email);
  };

  _onLoginEquinixSSOClick = () => {
    window.location.assign(`${Config.AUTH_URL}oauth2/authorization/sso.equinix.com`);
  };

  isValidEmail = (email) => {
    //EQX-2744: To specify which special characters you want to be valid before the @, add them after the \\?
    const regex = /^[\w-\\.\\?+']+@([\w-]+\.)+[\w-]{2,4}$/;
    return regex.test(email);
  };

  renderUnsent() {
    const emailSubject = encodeURIComponent('Request Access to WorkBench');
    const emailBody = encodeURIComponent(
      `Hi Equinix WorkBench team,

Please can I get access to the WorkBench tool?

Thanks.

Note: Equinix typically takes 3-5 business days to complete setup and enable your access, and will inform you when ready.`
    );
    return (
      <form>
        <div className="body-container">
          <p className="sign-in">Equinix User Sign In</p>
          <Button
            type="button"
            color="red"
            text="Login with Equinix SSO"
            isStretch
            Icon={EquinixLogo}
            iconColor="white"
            EndIcon={ArrowIcon}
            onClick={this._onLoginEquinixSSOClick}
          />
        </div>
        <div className="box-footer">
          <p className="sign-in">Partner Sign In</p>
          <span className="subtitle">GET A LOGIN LINK</span>
          <div className="input-container">
            <TextInput className="textInput" placeholder="Enter your email..." value={this.state.email} onValueChange={this._onValueChange} autoFocus={true} />
            <Button text="Login" onClick={this._onLoginClick} />
          </div>
          <span className="subtitle">NEW USERS</span>
          <Button
            isInverse
            isStretch
            color="gray"
            text="Request access by e-mail"
            onClick={() => (window.location.href = `mailto:${Config.SUPPORT_EMAIL}?subject=${emailSubject}&body=${emailBody}`)}
          />
          <span className="links">
            Have another question:{' '}
            <a href={onBoardingPDF} target="_blank" rel="noopener noreferrer">
              Read Onboarding FAQ.
            </a>
          </span>
        </div>
      </form>
    );
  }

  renderSent() {
    return (
      <form className="message">
        <h2>Your link has been sent.</h2>
        <p>Check your inbox for a single-use login link.</p>
      </form>
    );
  }

  render() {
    return this.props.emailSent ? this.renderSent() : this.renderUnsent();
  }
}

export default withRouter(LoginView);
